import { AppData } from "../../game/AppData";
import { WebUtil } from "../web/WebUtil";
/**
 * LangLoaderUtil.ts
 */
export class LangLoaderUtil {
    /**
     * Get origin for lang file request url based on environment, game url parameters, or deploy type.
     */
    static getLangOrigin() {
        const gameDev = WebUtil.getUrlParameter("gameDev") === "true" ||
            WebUtil.getUrlParameter("testConfig") == "local" ||
            LangLoaderUtil.isStaging(window.location.hostname) ||
            WebUtil.getUrlParameter("testNative") == "true" ||
            LangLoaderUtil.isBlastworksStaging();
        //we need to support 4 situations. web staging, web prod, native staging native prod
        //This is on web, may be prod or staging. on native it will be localhost
        let url = window.location.origin + "/";
        let isAlchemy = true;
        if (url.indexOf("alchemy") == -1) {
            //if this is not alchemy, then we need to load the currency from alchemy
            isAlchemy = false;
        }
        if (gameDev) {
            url = "https://alchemy-sta.gamingrealms.net/";
        }
        else if (AppData.DEPLOY_TYPE.isNative() /* || AppData.DEPLOY_TYPE.isNativeLite() */ ||
            LangLoaderUtil.isBlastworks() ||
            !isAlchemy) {
            url = "https://alchemy.gamingrealms.net/";
        }
        return url;
    }
    /**
     * Get origin for help lang file request url based on environment, game url parameters, or deploy type.
     */
    static getHelpLangOrigin() {
        const gameDev = WebUtil.getUrlParameter("gameDev") === "true" ||
            LangLoaderUtil.isBlastworksStaging();
        let url = window.location.origin + "/";
        if (AppData.DEPLOY_TYPE.isNative() /* || AppData.DEPLOY_TYPE.isNativeLite() */ ||
            gameDev) {
            url = "https://alchemy-sta.gamingrealms.net/";
        }
        else if (LangLoaderUtil.isBlastworks()) {
            url = "https://alchemy.gamingrealms.net/";
        }
        return url;
    }
    /**
     * Checks if operator is one of blastwork's and in stage environment.
     */
    static isBlastworksStaging() {
        const isStaging = LangLoaderUtil.isStaging(WebUtil.getUrlParameter("gameServer"));
        return LangLoaderUtil.isBlastworks() && isStaging;
    }
    /**
     * Checks if operator is one of blastwork's.
     */
    static isBlastworks() {
        let urlParam = WebUtil.getUrlParameter("operator");
        if (urlParam) {
            return urlParam.includes("blastworks");
        }
        return false;
    }
    /**
     * Checks if in stage environment.
     *
     * @example
     * LangLoaderUtil.isStaging(window.location.hostname)
     */
    static isStaging(location) {
        if (!location) {
            return false;
        }
        return location.includes("-sta");
    }
}
//# sourceMappingURL=LangLoaderUtil.js.map